<template>
    <div class="fin-mb-10">

        <h3 class="fin-fin-mb-3">Referrer Teams</h3>

        <el-form ref="form" :model="form" label-position="top">

            <div class="fin-grid fin-grid-cols-6 fin-gap-5 fin-mb-5">

                <div v-for="team in teams" :key="team.id">

                    <el-form-item class="fin-w-full" :label="team.name" prop="email">
                        <el-switch
                            style="display: block"
                            v-model="form.teams[team.id]"
                            :active-value="true"
                            :inactive-value="false"
                            active-text="Active"
                        ></el-switch>
                    </el-form-item>

                    <el-form-item class="fin-w-full" :label="`Team ${team.name} Email`">
                        <el-input :disabled="!form.teams[team.id]" class="fin-w-full" type="email" v-model="form.emails[team.id]" :placeholder="referrer.email"></el-input>
                    </el-form-item>

                </div>
            </div>

            <div>
                <el-form-item label="Current Team" prop="current_team_id">
                    Set the current team to the team you would like to run reports as
                    <el-select class="fin-w-full" clearable v-model="form.referrer.current_team_id" placeholder="Current Team">
                        <el-option v-for="team in activeTeams" :key="team.id" :label="team.name" :value="team.id"></el-option>
                    </el-select>
                </el-form-item>
            </div>

        </el-form>
    </div>

</template>

<script>
export default {
    name: "ReferrerTeamSelector",
    props: {
        teams: {
            type: Array,
            required: false,
            default: function() {
                return []
            }
        },
        referrer: {
            required: true
        },
        token: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            saveDelay: 1000,
            saveTimeout: null,
            abortController: null,
            form: {
                teams: {},
                emails: {},
                referrer: this.referrer
            },
        }
    },

    mounted() {
        if (_.size(_.get(this.referrer, 'teams', [])) > 0) {
            this.referrer.teams.forEach(team => {
                if (team.teamable) {
                    Vue.set(this.form.teams, team.teamable.team_id, true)
                    Vue.set(this.form.emails, team.teamable.team_id, team.teamable.email)
                }
            })
        }
    },


    computed: {
        activeTeams() {
            let activeTeams = []
            let formTeams = Object.entries(this.form.teams)
            formTeams.forEach(formTeam => {
                if (formTeam[1]) {
                    activeTeams.push(Number(formTeam[0]))
                }
            })
            return this.teams.filter(teams => activeTeams.includes(Number(teams.id)))
        }
    },

    methods: {
        async save() {
            await this.$tenant.post(`/admin/referrers/teams/${this.referrer.id}`, this.form)
                .then(res => {
                    console.log(res)
                })
                .catch((err) => {
                    console.error(err)
                })
        },
    },

    watch: {
        form: {
            handler() {
                if (this.saveTimeout) clearTimeout(this.saveTimeout)
                this.saveTimeout = setTimeout(() => {
                    this.save()
                }, this.saveDelay)
            },
            deep: true
        }
    },

}
</script>

<style lang="scss" scoped>
    .el-form :deep {
        .el-form-item {
            .el-form-item__label {
                @apply fin-m-0 fin-p-0 #{!important}
            }

            @apply fin-m-0 #{!important}
        }
    }
</style>
